// Textos do Histórico do colaborador (01/11/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dp.colaboradores.titulo': 'Histórico do colaborador',
    'dp.colaboradores.ajuda': 'O quadro inteiro, sem repetir a pessoa: as matrículas de quem foi transferido viram uma linha só, na matrícula atual. A ficha junta o ano da pessoa nos módulos do DP e da Logística, e cada bloco aparece só para quem pode ler o módulo dele.',
    'dp.colaboradores.abrir': 'Abrir',
    'dp.colaboradores.abrirFichaDe': 'Abrir a ficha de {{nome}}',
    'dp.colaboradores.abrirModulo': 'Abrir {{modulo}}',
    'dp.colaboradores.ano': 'Ano',
    'dp.colaboradores.matricula': 'Matrícula',
    'dp.colaboradores.funcao': 'Função',
    'dp.colaboradores.admissao': 'Admissão',
    'dp.colaboradores.demissao': 'Demissão',
    'dp.colaboradores.outrasMatriculas': 'Outras matrículas da pessoa, {{lista}}',
    'dp.colaboradores.outrasMatriculasDica': 'Outras matrículas da mesma pessoa',
    'dp.colaboradores.linhaDoTempo': 'Linha do tempo de {{ano}}',
    'dp.colaboradores.semEventos': 'Nenhum evento neste ano.',
    'dp.colaboradores.cortado': 'Mostrando os {{teto}} eventos mais recentes de {{total}}. Os números acima contam todos.',
    'dp.colaboradores.semCadastro': 'Esta pessoa não está no cadastro do Hub. Jornada, gestões, bônus, multas e CNH não se aplicam aqui.',
    'dp.colaboradores.kpi.total': 'Quadro',
    'dp.colaboradores.kpi.sairam': 'Saíram',
    'dp.colaboradores.situacaoDaPessoa.ativo': 'Ativo',
    'dp.colaboradores.situacaoDaPessoa.afastado': 'Afastado',
    'dp.colaboradores.situacaoDaPessoa.ferias': 'Férias',
    'dp.colaboradores.situacaoDaPessoa.bloqueado': 'Bloqueado',
    'dp.colaboradores.situacaoDaPessoa.demitido': 'Demitido',
    'dp.colaboradores.situacaoDaPessoa.transferido': 'Transferido',
    'dp.colaboradores.situacao.todas': 'Todas',
    'dp.colaboradores.situacao.ativo': 'Ativos',
    'dp.colaboradores.situacao.afastado': 'Afastados',
    'dp.colaboradores.situacao.ferias': 'Férias',
    'dp.colaboradores.situacao.bloqueado': 'Bloqueados',
    'dp.colaboradores.situacao.demitido': 'Demitidos',
    'dp.colaboradores.situacao.transferido': 'Transferidos',
    'dp.colaboradores.cartao.faltas': 'Faltas',
    'dp.colaboradores.cartao.suspensoes': 'Suspensões',
    'dp.colaboradores.cartao.gestoes': 'Gestões',
    'dp.colaboradores.cartao.gestoesDica': '{{n}} pendentes de aplicação. Canceladas e desconsideradas não contam.',
    'dp.colaboradores.cartao.he50': 'Hora extra 50%',
    'dp.colaboradores.cartao.he100': 'Hora extra 100%',
    'dp.colaboradores.cartao.infracoes': 'Infrações de jornada',
    'dp.colaboradores.cartao.infracoesDica': '{{n}} sem tratativa',
    'dp.colaboradores.cartao.bonus': 'Bônus recebido',
    'dp.colaboradores.cartao.vale': 'Vale recebido',
    'dp.colaboradores.cartao.emApuracao': 'Só o que já fechou. {{valor}} ainda em apuração.',
    'dp.colaboradores.cartao.ponto': 'Ponto sem assinar',
    'dp.colaboradores.cartao.pontoDica': '{{n}} com o prazo vencido',
    'dp.colaboradores.cartao.ausencias': 'Ausências',
    'dp.colaboradores.cartao.multas': 'Multas',
    'dp.colaboradores.cartao.multasDica': '{{n}} pontos no ano',
    'dp.colaboradores.cartao.sinistros': 'Sinistros',
    'dp.colaboradores.cartao.exames': 'Exames',
    'dp.colaboradores.cartao.examesDica': '{{n}} ainda pendentes',
    'dp.colaboradores.cartao.toxicologico': 'Toxicológico',
    'dp.colaboradores.cartao.cnh': 'Vencimento da CNH',
    'dp.colaboradores.cartao.cnhDica': 'Categoria {{categoria}}',
    'dp.colaboradores.cartao.plano': 'Meses de plano de saúde',
    'dp.colaboradores.cartao.coparticipacao': 'Coparticipação',
    'dp.colaboradores.cartao.desligamento': 'Último dia',
    'dp.colaboradores.evento.falta': 'Falta',
    'dp.colaboradores.evento.suspensao': 'Suspensão',
    'dp.colaboradores.evento.gestao': 'Gestão',
    'dp.colaboradores.evento.bonus': 'Bônus',
    'dp.colaboradores.evento.vale': 'Vale-alimentação',
    'dp.colaboradores.evento.ponto': 'Ponto sem assinar',
    'dp.colaboradores.evento.ausencia': 'Ausência',
    'dp.colaboradores.evento.multa': 'Multa',
    'dp.colaboradores.evento.sinistro': 'Sinistro',
    'dp.colaboradores.evento.exame': 'Exame',
    'dp.colaboradores.evento.toxicologico': 'Toxicológico',
    'dp.colaboradores.evento.cnh': 'CNH',
    'dp.colaboradores.evento.plano': 'Plano de saúde',
    'dp.colaboradores.evento.desligamento': 'Desligamento',
  },
  en: {
    'dp.colaboradores.titulo': 'Employee history',
    'dp.colaboradores.ajuda': 'The whole workforce, without repeating anyone: the IDs of a transferred employee become one row, under the current ID. The record gathers the year across the HR and Logistics modules, and each block shows only to whoever can read its module.',
    'dp.colaboradores.abrir': 'Open',
    'dp.colaboradores.abrirFichaDe': 'Open the record of {{nome}}',
    'dp.colaboradores.abrirModulo': 'Open {{modulo}}',
    'dp.colaboradores.ano': 'Year',
    'dp.colaboradores.matricula': 'Employee ID',
    'dp.colaboradores.funcao': 'Role',
    'dp.colaboradores.admissao': 'Hired on',
    'dp.colaboradores.demissao': 'Terminated on',
    'dp.colaboradores.outrasMatriculas': 'Other IDs of this person, {{lista}}',
    'dp.colaboradores.outrasMatriculasDica': 'Other IDs of the same person',
    'dp.colaboradores.linhaDoTempo': 'Timeline of {{ano}}',
    'dp.colaboradores.semEventos': 'No events this year.',
    'dp.colaboradores.cortado': 'Showing the {{teto}} most recent events out of {{total}}. The numbers above count them all.',
    'dp.colaboradores.semCadastro': 'This person is not in the Hub registry. Working hours, warnings, bonus, fines and license do not apply here.',
    'dp.colaboradores.kpi.total': 'Workforce',
    'dp.colaboradores.kpi.sairam': 'Left',
    'dp.colaboradores.situacaoDaPessoa.ativo': 'Active',
    'dp.colaboradores.situacaoDaPessoa.afastado': 'On leave',
    'dp.colaboradores.situacaoDaPessoa.ferias': 'On vacation',
    'dp.colaboradores.situacaoDaPessoa.bloqueado': 'Blocked',
    'dp.colaboradores.situacaoDaPessoa.demitido': 'Terminated',
    'dp.colaboradores.situacaoDaPessoa.transferido': 'Transferred',
    'dp.colaboradores.situacao.todas': 'All',
    'dp.colaboradores.situacao.ativo': 'Active',
    'dp.colaboradores.situacao.afastado': 'On leave',
    'dp.colaboradores.situacao.ferias': 'On vacation',
    'dp.colaboradores.situacao.bloqueado': 'Blocked',
    'dp.colaboradores.situacao.demitido': 'Terminated',
    'dp.colaboradores.situacao.transferido': 'Transferred',
    'dp.colaboradores.cartao.faltas': 'Absences',
    'dp.colaboradores.cartao.suspensoes': 'Suspensions',
    'dp.colaboradores.cartao.gestoes': 'Warnings',
    'dp.colaboradores.cartao.gestoesDica': '{{n}} waiting to be applied. Canceled and dismissed ones do not count.',
    'dp.colaboradores.cartao.he50': 'Overtime 50%',
    'dp.colaboradores.cartao.he100': 'Overtime 100%',
    'dp.colaboradores.cartao.infracoes': 'Working hour violations',
    'dp.colaboradores.cartao.infracoesDica': '{{n}} not handled',
    'dp.colaboradores.cartao.bonus': 'Bonus received',
    'dp.colaboradores.cartao.vale': 'Meal voucher received',
    'dp.colaboradores.cartao.emApuracao': 'Closed periods only. {{valor}} still being calculated.',
    'dp.colaboradores.cartao.ponto': 'Unsigned timesheets',
    'dp.colaboradores.cartao.pontoDica': '{{n}} past the deadline',
    'dp.colaboradores.cartao.ausencias': 'Leaves',
    'dp.colaboradores.cartao.multas': 'Fines',
    'dp.colaboradores.cartao.multasDica': '{{n}} points in the year',
    'dp.colaboradores.cartao.sinistros': 'Claims',
    'dp.colaboradores.cartao.exames': 'Exams',
    'dp.colaboradores.cartao.examesDica': '{{n}} still pending',
    'dp.colaboradores.cartao.toxicologico': 'Drug test',
    'dp.colaboradores.cartao.cnh': 'License expiry',
    'dp.colaboradores.cartao.cnhDica': 'Category {{categoria}}',
    'dp.colaboradores.cartao.plano': 'Months of health plan',
    'dp.colaboradores.cartao.coparticipacao': 'Co-payment',
    'dp.colaboradores.cartao.desligamento': 'Last day',
    'dp.colaboradores.evento.falta': 'Absence',
    'dp.colaboradores.evento.suspensao': 'Suspension',
    'dp.colaboradores.evento.gestao': 'Warning',
    'dp.colaboradores.evento.bonus': 'Bonus',
    'dp.colaboradores.evento.vale': 'Meal voucher',
    'dp.colaboradores.evento.ponto': 'Unsigned timesheet',
    'dp.colaboradores.evento.ausencia': 'Leave',
    'dp.colaboradores.evento.multa': 'Fine',
    'dp.colaboradores.evento.sinistro': 'Claim',
    'dp.colaboradores.evento.exame': 'Exam',
    'dp.colaboradores.evento.toxicologico': 'Drug test',
    'dp.colaboradores.evento.cnh': 'License',
    'dp.colaboradores.evento.plano': 'Health plan',
    'dp.colaboradores.evento.desligamento': 'Termination',
  },
  es: {
    'dp.colaboradores.titulo': 'Historial del colaborador',
    'dp.colaboradores.ajuda': 'Toda la plantilla, sin repetir a la persona: las matrículas de quien fue trasladado se vuelven una sola fila, en la matrícula actual. La ficha reúne el año de la persona en los módulos de RR. HH. y Logística, y cada bloque aparece solo para quien puede leer su módulo.',
    'dp.colaboradores.abrir': 'Abrir',
    'dp.colaboradores.abrirFichaDe': 'Abrir la ficha de {{nome}}',
    'dp.colaboradores.abrirModulo': 'Abrir {{modulo}}',
    'dp.colaboradores.ano': 'Año',
    'dp.colaboradores.matricula': 'Matrícula',
    'dp.colaboradores.funcao': 'Función',
    'dp.colaboradores.admissao': 'Ingreso',
    'dp.colaboradores.demissao': 'Baja',
    'dp.colaboradores.outrasMatriculas': 'Otras matrículas de la persona, {{lista}}',
    'dp.colaboradores.outrasMatriculasDica': 'Otras matrículas de la misma persona',
    'dp.colaboradores.linhaDoTempo': 'Línea de tiempo de {{ano}}',
    'dp.colaboradores.semEventos': 'Ningún evento este año.',
    'dp.colaboradores.cortado': 'Mostrando los {{teto}} eventos más recientes de {{total}}. Los números de arriba cuentan todos.',
    'dp.colaboradores.semCadastro': 'Esta persona no está en el registro del Hub. Jornada, gestiones, bono, multas y licencia no se aplican aquí.',
    'dp.colaboradores.kpi.total': 'Plantilla',
    'dp.colaboradores.kpi.sairam': 'Salieron',
    'dp.colaboradores.situacaoDaPessoa.ativo': 'Activo',
    'dp.colaboradores.situacaoDaPessoa.afastado': 'De baja',
    'dp.colaboradores.situacaoDaPessoa.ferias': 'De vacaciones',
    'dp.colaboradores.situacaoDaPessoa.bloqueado': 'Bloqueado',
    'dp.colaboradores.situacaoDaPessoa.demitido': 'Despedido',
    'dp.colaboradores.situacaoDaPessoa.transferido': 'Transferido',
    'dp.colaboradores.situacao.todas': 'Todas',
    'dp.colaboradores.situacao.ativo': 'Activos',
    'dp.colaboradores.situacao.afastado': 'De baja',
    'dp.colaboradores.situacao.ferias': 'De vacaciones',
    'dp.colaboradores.situacao.bloqueado': 'Bloqueados',
    'dp.colaboradores.situacao.demitido': 'Desvinculados',
    'dp.colaboradores.situacao.transferido': 'Trasladados',
    'dp.colaboradores.cartao.faltas': 'Faltas',
    'dp.colaboradores.cartao.suspensoes': 'Suspensiones',
    'dp.colaboradores.cartao.gestoes': 'Gestiones',
    'dp.colaboradores.cartao.gestoesDica': '{{n}} pendientes de aplicación. Las canceladas y desestimadas no cuentan.',
    'dp.colaboradores.cartao.he50': 'Hora extra 50%',
    'dp.colaboradores.cartao.he100': 'Hora extra 100%',
    'dp.colaboradores.cartao.infracoes': 'Infracciones de jornada',
    'dp.colaboradores.cartao.infracoesDica': '{{n}} sin tratar',
    'dp.colaboradores.cartao.bonus': 'Bono recibido',
    'dp.colaboradores.cartao.vale': 'Vale recibido',
    'dp.colaboradores.cartao.emApuracao': 'Solo lo ya cerrado. {{valor}} aún en cálculo.',
    'dp.colaboradores.cartao.ponto': 'Hojas sin firmar',
    'dp.colaboradores.cartao.pontoDica': '{{n}} con el plazo vencido',
    'dp.colaboradores.cartao.ausencias': 'Ausencias',
    'dp.colaboradores.cartao.multas': 'Multas',
    'dp.colaboradores.cartao.multasDica': '{{n}} puntos en el año',
    'dp.colaboradores.cartao.sinistros': 'Siniestros',
    'dp.colaboradores.cartao.exames': 'Exámenes',
    'dp.colaboradores.cartao.examesDica': '{{n}} aún pendientes',
    'dp.colaboradores.cartao.toxicologico': 'Toxicológico',
    'dp.colaboradores.cartao.cnh': 'Vencimiento de la licencia',
    'dp.colaboradores.cartao.cnhDica': 'Categoría {{categoria}}',
    'dp.colaboradores.cartao.plano': 'Meses de plan de salud',
    'dp.colaboradores.cartao.coparticipacao': 'Copago',
    'dp.colaboradores.cartao.desligamento': 'Último día',
    'dp.colaboradores.evento.falta': 'Falta',
    'dp.colaboradores.evento.suspensao': 'Suspensión',
    'dp.colaboradores.evento.gestao': 'Gestión',
    'dp.colaboradores.evento.bonus': 'Bono',
    'dp.colaboradores.evento.vale': 'Vale de alimentación',
    'dp.colaboradores.evento.ponto': 'Hoja sin firmar',
    'dp.colaboradores.evento.ausencia': 'Ausencia',
    'dp.colaboradores.evento.multa': 'Multa',
    'dp.colaboradores.evento.sinistro': 'Siniestro',
    'dp.colaboradores.evento.exame': 'Examen',
    'dp.colaboradores.evento.toxicologico': 'Toxicológico',
    'dp.colaboradores.evento.cnh': 'Licencia',
    'dp.colaboradores.evento.plano': 'Plan de salud',
    'dp.colaboradores.evento.desligamento': 'Desvinculación',
  },
}
